import styled from 'styled-components';

import { getThemeColor, getTypographyStyle, media } from '@utils/styled';

import { StyledCardLink } from '@common/components/Card/Card.styled';
import Hr from '@common/components/Hr';
import * as Icons from '@common/components/Icons';
import Typography from '@common/components/Typography';

export const CardsWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  ${({ theme }) => theme.getFluidSpacing('grid-gap', 'widthBased', 1)};
  ${({ theme }) => theme.getFluidSpacing('margin-bottom', 'widthBased', 1)};

  ${media.from800up`
    grid-template-columns: 1fr 1fr;
  `}
`;

export const VIPCardCard = styled(StyledCardLink)`
  flex-direction: column;
`;

export const VIPCardContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: auto;
`;

export const VIPCard = styled.img`
  ${({ theme }) => theme.getFluidAttribute('width', 12.8, 20)};
  height: 100%;
  margin-bottom: -1px;
`;

export const VIPCardHr = styled(Hr)`
  margin: 0;
  ${({ theme }) => theme.getFluidSpacing('margin-bottom', 'equal', 3)};
`;

export const VIPCardTitle = styled(Typography).attrs({
  customAs: 'h2',
  variant: 'body3',
})`
  margin: 0;
  font-weight: 500;
  text-align: center;

  ${media.from480up`
    ${getTypographyStyle('h5')};
  `}
`;

export const LoginIcon = styled(Icons.Login)`
  ${({ theme }) => theme.getFluidAttribute('width', 3.3, 4.7)};
  fill: ${getThemeColor('bluegrey.70')};
`;

export const FormIcon = styled(Icons.Form)`
  ${({ theme }) => theme.getFluidAttribute('width', 3.3, 5)};
  fill: ${getThemeColor('bluegrey.70')};
`;
